export default __webpack_public_path__ + "static/media/foto3.d84be010.webp";